/**
 * Notification Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface TenderiMkBillingInformationDto { 
    paymentOption: TenderiMkBillingInformationDto.PaymentOptionEnum;
    clientName: string;
    taxId?: string;
    foreignCountry: boolean;
    country?: string;
    email: string;
    contactAddress: string;
    contactCity: string;
    contactPerson?: string;
    contactPhone?: string;
}
export namespace TenderiMkBillingInformationDto {
    export type PaymentOptionEnum = 'INVOICE' | 'LINK';
    export const PaymentOptionEnum = {
        INVOICE: 'INVOICE' as PaymentOptionEnum,
        LINK: 'LINK' as PaymentOptionEnum
    };
}